import { Component, inject, LOCALE_ID, OnInit } from '@angular/core';
import { TokenService } from '../services/auth-token-service';
import { LAST_USED_ORGANIZATION_STORAGE_KEY, commonImports } from '../common';
import { backendUrlSubject } from '../services/global-storage';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { customAlphabet } from 'nanoid';
import { Meta } from '@angular/platform-browser';
import { UtilsService } from '../services/utils';

@Component({
  selector: 'app-root',
  imports: [...commonImports],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [],
})
export class AppComponent implements OnInit {
  title = 'shooting-competitions';

  public readonly localeId = inject(LOCALE_ID);

  constructor(
    private snackBar: MatSnackBar,
    private tokenService: TokenService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private meta: Meta,
    private utilsService: UtilsService,
  ) {}

  async ngOnInit() {
    // Initialize nanoid with custom alphabet to avoid ambiguous characters
    customAlphabet('1234567890' + 'abcdefghijklmnopqrstuvwxyz' + 'abcdefghijklmnopqrstuvwxyz'.toUpperCase(), 21);

    const env = await this.loadEnv();
    backendUrlSubject.next(env.backendUrl);

    if (window.location.pathname === '/') {
      const lastOrgId = localStorage.getItem(LAST_USED_ORGANIZATION_STORAGE_KEY);
      if (lastOrgId != null) {
        this.router.navigate(['/organizations/', lastOrgId, 'competitions']);
      }
    }

    this.meta.addTag({
      httpEquiv: 'Content-Language',
      content: this.localeId,
    });
    this.utilsService.resetPageMeta();
  }

  async loadEnv() {
    try {
      const response = await fetch('/env-config.json');
      return await response.json();
    } catch (e: unknown) {
      this.snackBar.open(`❗️ Critical error. Can't load environment: ${e instanceof Error ? e.message : e}`, 'Close');
      throw e;
    }
  }
}
